import React from 'react'

export default function DashboardReference({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2584_1838)">
        <path d="M4 20V22H8.586L2 28.586L3.414 30L10 23.414V28H12V20H4Z" fill={color} />
        <path d="M26 21H24V26H26V21Z" fill={color} />
        <path d="M22 16H20V26H22V16Z" fill={color} />
        <path d="M18 18H16V26H18V18Z" fill={color} />
        <path d="M28 2H4C3.46973 2.00053 2.96133 2.21141 2.58637 2.58637C2.21141 2.96133 2.00053 3.46973 2 4V16H4V13H28.001L28.002 28H16V30H28C28.5302 29.9993 29.0385 29.7883 29.4134 29.4134C29.7883 29.0385 29.9993 28.5302 30 28V4C29.9994 3.46975 29.7885 2.9614 29.4135 2.58646C29.0386 2.21152 28.5302 2.00061 28 2ZM12 11H4V4H12V11ZM14 11V4H28L28.0007 11H14Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_2584_1838">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
